export async function mediaBase64FromId(
  get: (id: string) => Promise<Blob | null>,
  toBase64: (blob: Blob) => Promise<string>,
  mediaId: string | null | undefined,
): Promise<string | null> {
  const id = mediaId?.trim();
  if (!id) return null;
  const blob = await get(id);
  if (!blob?.size) return null;
  return toBase64(blob);
}
